import React, { useEffect, useState } from 'react'
import { supabase } from '../supabase'

interface Platform {
  id: number
  category: string
  name: string
  url: string
}

const MediaWorldPage = () => {
  const [platforms, setPlatforms] = useState<Platform[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase.from('platforms').select('*')
      if (error) {
        console.error('Supabase 错误:', error.message)
      } else {
        setPlatforms(data || [])
      }
      setLoading(false)
    }

    fetchData()
  }, [])

  // 按 category 分组
  const grouped = platforms.reduce<Record<string, Platform[]>>((acc, item) => {
    acc[item.category] = acc[item.category] || []
    acc[item.category].push(item)
    return acc
  }, {})

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Our Media World
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Powered by Supabase - all platforms are loaded from the database.
          </p>
        </div>

        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : (
          <div className="space-y-12">
            {Object.entries(grouped).map(([category, items], index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  {category}
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {items.map((platform) => (
                    <a
                      key={platform.id}
                      href={platform.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <span className="text-gray-700 hover:text-blue-600">
                        {platform.name}
                      </span>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default MediaWorldPage
